import { useEffect, useState } from "react";

const useToken = (user) => {
  const [token, setToken] = useState(null);
  const [tokenLoading, setTokenLoading] = useState(false);

  useEffect(() => {
    async function run() {
      if (user?.user?.email) {
        setTokenLoading(true);
        const url = `https://evening-peak-35730.herokuapp.com/generateToken/${user?.user?.email}`;
        const res = await fetch(url);
        const data = await res.json();
        if (data?.success) {
          setTokenLoading(false);
          localStorage.setItem("accessToken", data?.token);
          setToken(data?.token);
        }
      }
    }
    run();
  }, [user]);

  return [token, tokenLoading];
};

export default useToken;
